import React from 'react';
import { graphql, Link as GLink, useStaticQuery } from 'gatsby';
import { Container, Box, Flex, css, Link } from 'theme-ui';
import { normalizeBlockContentNodes } from '@blocks-helpers';
import ContentText from '@solid-ui-components/ContentText';
import ContentImages from '@solid-ui-components/ContentImages';
import ContentButtons from '@solid-ui-components/ContentButtons';
import WithDefaultContent from '@solid-ui-blocks/WithDefaultContent';
import styles from './styles';
import Divider from '@solid-ui-components/Divider';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

const {
  footerLogo,
  footer,
  wrapper,
  buttonsWrapper,
  buttonColumn,
  bottomFooter,
  bottomFooterWrapper,
  buttonRow,
  bottomButtons,
  topButtons,
  dateSign,
  marketButtons,
} = styles;

const renderFooterButtons = (buttons, top) =>
  buttons?.map(
    ({ text, buttons, images }, index) =>
      buttons && (
        <Flex key={`item-${index}-${top}`} sx={top ? buttonColumn : buttonRow}>
          <ContentText content={text?.[0]} />
          <ContentButtons
            content={buttons}
            variant='vertical'
            wrapperStyles={{
              ...buttonsWrapper,
              ...(top ? topButtons : bottomButtons),
            }}
          />
          <Flex sx={marketButtons}>
            {images?.map(({ alt, src, link }) => {
              const imageData = getImage(src);
              if (imageData) {
                return (
                  <Link target='_blank' href={link.link} key={alt}>
                    <GatsbyImage image={imageData} alt={alt} />
                  </Link>
                );
              }
            })}
          </Flex>
        </Flex>
      )
  );

  const FooterBlock01 = () => {
    const { allBlockContent } = useStaticQuery(query);
    const content = normalizeBlockContentNodes(allBlockContent?.nodes);
    const { images, collection } = content[`footer-common`];
    return (
      <Box sx={wrapper}>
        <Container variant='container'>
          <div>
            <Flex sx={footer}>
              <div>
                <div css={css({ width: 'fit-content' })}>
                  <Box sx={footerLogo}>
                    <GLink to='/'>
                      <ContentImages content={{ images }} imageEffect='fadeIn' />
                    </GLink>
                  </Box>
                  <Box sx={dateSign}>
                    © {new Date().getFullYear()} TS TECHNOLOGIES
                  </Box>
                  {/* Отступ сверху для виджета Product Hunt */}
                  <Box sx={{ marginTop: '10px' }}>
                    <a href="https://www.producthunt.com/posts/targpatrol?embed=true&utm_source=badge-featured&utm_medium=badge&utm_souce=badge-targpatrol" target="_blank">
                      <img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=608190&theme=light" alt="TARGPatrol - Business Task Management App: Inspections, Checklists, Tours | Product Hunt" style={{ width: '250px', height: '54px' }} />
                    </a>
                  </Box>
                </div>
              </div>
              {renderFooterButtons(collection?.slice(0, 3), true)}
            </Flex>
          </div>
          <Divider space='40px' color='gray200' />
          <Box sx={bottomFooterWrapper}>
            <Flex sx={bottomFooter}>
              {renderFooterButtons(collection?.slice(3), false)}
            </Flex>
          </Box>
        </Container>
      </Box>
    );
  };  

export const query = graphql`
  query FooterBlockContent {
    allBlockContent(
      filter: { page: { in: ["targpatrol-en/index", "shared"] } }
    ) {
      nodes {
        ...BlockContent
      }
    }
  }
`;

export default WithDefaultContent(FooterBlock01);
